/** Generic Chart System — Component Type Registry (v2.7.0) */

const EDGEN_CHART_COMPONENT_TYPES = [
  "LineChart",
  "VerticalBarChart",
  "GroupedComparisonBarChart",
  "HorizontalMixBarChart",
  "DonutCompositionChart",
] as const;

const EDGEN_CHART_COMPONENT_TYPE_SET = new Set<string>(
  EDGEN_CHART_COMPONENT_TYPES,
);

export const isEdgenChartComponentType = (type: unknown): type is string =>
  typeof type === "string" && EDGEN_CHART_COMPONENT_TYPE_SET.has(type);
